export enum PAYMENT_ACTION_TYPES {
  SET_CART = "payment/SET_CART",
  REMOVE_CART = "payment/REMOVE_CART",
}
